import LoadingIndicator from './LoadingIndicator';

export default {
  name: 'loadingIndicator',
  title: 'Visa laddningsidikator',
  navbar: {
    component: LoadingIndicator
  }
};
